import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import StringTableService from '../../services/string-table'
import RouteMapService from '../../services/route-map'

const loginRoute = StringTableService.getString(StringTableService.keys.loginRoute)
const unauthorizeRoute = RouteMapService.lookupMap['403'].route

class AuthenticatedRoute extends Component {

    static propTypes = {
        authenticated: PropTypes.bool,
        authorizer: PropTypes.object,
        checkedAuthAtStartup: PropTypes.bool,
        component: PropTypes.func,
        computedMatch: PropTypes.object,
        location: PropTypes.object,
        path: PropTypes.string,
        policy: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        workspace: PropTypes.object,
    }

    constructor(props) {
        super(props)
    }

    render() {
        if (!this.props.checkedAuthAtStartup) {
            return null
        }
        const TargetComponent = this.props.component
        if (!this.props.authenticated) {
            return <Redirect to={loginRoute} />
        }

        const { policy, authorizer, workspace } = this.props

        if (!authorizer.allowNav(policy, workspace)) {
            return <Redirect to={unauthorizeRoute} />
        }

        const props = {
            location: this.props.location,
            routeMatch: this.props.computedMatch
        }
        return <TargetComponent {...props} />
    }

}

const mapStateToProps = (state) => {

    const { auth } = state

    return {
        authenticated: auth.authenticated,
        checkedAuthAtStartup: auth.startupCheckDone
    }

}

import { withWorkspace, withAuthorizer } from '../../containers/high-order-components'

export default connect(mapStateToProps)(
    withAuthorizer(
        withWorkspace(
            AuthenticatedRoute
        )
    )
)



// WEBPACK FOOTER //
// src/components/auth/authenticated-route.js